import { useParams } from 'react-router-dom';
import { productService } from '../../../services/productService';
import type { ImportField } from '../../../types/import';
import { ExcelImportPage } from '../../common/import';

const PRODUCT_IMPORT_FIELDS: ImportField[] = [
  { key: 'name', label: 'Колонка з назвою', required: true },
  { key: 'code', label: 'Колонка з кодом' },
];

export default function ProductImportPage() {
  const { id } = useParams<{ id: string }>();
  const companyId = id ? parseInt(id) : null;

  return (
    <ExcelImportPage
      title="Імпорт продуктів"
      description="Оберіть файл .xlsx, перший рядок якого містить заголовки. Далі вкажіть, яка колонка є назвою, а яка кодом. Продукти, що вже існують з такою ж назвою і кодом, пропускаються."
      companyId={companyId}
      backPath={`/companies/${companyId}/products`}
      backLabel="Назад"
      fields={PRODUCT_IMPORT_FIELDS}
      loadPreview={productService.previewImport}
      runImport={productService.importFromExcel}
    />
  );
}
